import { Box, Button, Drawer, List, ListItemButton, ListItemText } from '@mui/material';
import Logo from 'components-new/common/logo';
import { snakeCase } from 'lodash';
import { useState } from 'react';

const DRAWER_WIDTH = 280;

type Props = {
  whitelabel: any;
  pages: { key: string; label: string }[];
  setSection: (section: string) => void;
};

export default function NavMobile({ whitelabel, pages, setSection }: Props) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleClick = (id: string) => {
    const el = document.getElementById(id);

    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      handleDrawerClose();
    }
  };

  return (
    <>
      <Button endIcon={<i className="fas fa-bars" />} onClick={handleDrawerOpen}>
        Menu
      </Button>

      <Drawer
        open={drawerOpen}
        onClose={handleDrawerClose}
        ModalProps={{ keepMounted: true }}
        PaperProps={{
          sx: { width: DRAWER_WIDTH },
        }}
      >
        <Box sx={{ px: 2.5, py: 3, lineHeight: 0 }}>
          <Logo src={whitelabel?.logo} />
        </Box>

        <List sx={{ px: 0 }}>
          {pages.map((page) => (
            <ListItemButton
              key={page.key}
              sx={{ px: 2.5, py: 1.5 }}
              onClick={() => {
                const id = snakeCase(page.key);
                if (page.key === 'Floor Plans' || page.key === '3D Tour') {
                  setSection(id);
                }
                setTimeout(() => {
                  handleClick(id);
                }, 0);
              }}
            >
              <ListItemText disableTypography primary={page.label} />
            </ListItemButton>
          ))}
        </List>
      </Drawer>
    </>
  );
}
